import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ExternalLink, MapPin, Building2, BookOpen } from "lucide-react";

interface RelatedResource {
  title: string;
  description: string;
  url: string;
  type: 'state-guide' | 'industry-guide' | 'service-guide' | 'external';
}

interface RelatedResourcesProps {
  title?: string;
  resources: RelatedResource[];
}

const getResourceIcon = (type: RelatedResource['type']) => {
  switch (type) {
    case 'state-guide':
      return <MapPin className="h-5 w-5 text-primary" />;
    case 'industry-guide':
      return <Building2 className="h-5 w-5 text-primary" />;
    case 'service-guide':
      return <BookOpen className="h-5 w-5 text-primary" />;
    case 'external':
      return <ExternalLink className="h-5 w-5 text-primary" />;
    default:
      return <BookOpen className="h-5 w-5 text-primary" />;
  }
};

export const RelatedResources = ({ 
  title = "Related Resources", 
  resources 
}: RelatedResourcesProps) => {
  return (
    <div className="mb-12">
      <h2 className="text-2xl font-bold mb-6">{title}</h2>
      <div className="grid md:grid-cols-2 gap-6">
        {resources.map((resource, index) => (
          <Card key={index} className="hover:shadow-md transition-shadow">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center space-x-2 text-lg">
                {getResourceIcon(resource.type)}
                <span>{resource.title}</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground mb-4">{resource.description}</p>
              {resource.type === 'external' ? (
                <a
                  href={resource.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline font-medium"
                >
                  Learn More →
                </a>
              ) : (
                <Link
                  to={resource.url}
                  className="text-primary hover:underline font-medium"
                >
                  Learn More →
                </Link>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};